goog.provide("shadow.js.shim.module$$mui$material$IconButton$default");
shadow.js.shim.module$$mui$material$IconButton$default = shadow.js.require(388, {})["default"];
